import {Country} from "./country";

export class Operator {
    id: string;
    name: string;
    vatId: string;
    street: string;
    houseNumber: string;
    flatNumber: string;
    city: string;
    postCode: string;
    country: any;
    phone: string;
    email: string;
}
